import { render, staticRenderFns } from "./GermplasmUnifier.vue?vue&type=template&id=5a8f587e&"
import script from "./GermplasmUnifier.vue?vue&type=script&lang=js&"
export * from "./GermplasmUnifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports